import {
    iconStarEmpty,
    iconStarFilled,
    iconStarHalfFull,
} from '@shared/helpers/icons'
import {
    RatingStars as UiKitRatingStars,
    type RatingStarsProps,
} from 'swayok-react-mdb-ui-kit/components/Icon/RatingStars'

type ComponentProps = Omit<RatingStarsProps, 'iconStarEmpty' | 'iconStarFilled' | 'iconStarHalfFull'>

// Отображает рейтинг в виде набора из 5 иконок-звезд.
export function RatingStars(props: ComponentProps) {
    return (
        <UiKitRatingStars
            {...props}
            iconStarEmpty={iconStarEmpty}
            iconStarFilled={iconStarFilled}
            iconStarHalfFull={iconStarHalfFull}
        />
    )
}
